import * as React from 'react';
import cx from 'classnames';
import px from 'prop-types';
import { Product } from 'Common/types';

export default function ProductBadge({ className, badges: badgeOverride, product, marginRight, style }) {



    const badges = React.useMemo(
        () => badgeOverride || [...new Set(product?.MarketingBadges?.map((badge) => badge.toUpperCase()))],
        [product, badgeOverride]
    );

    return badges?.length ? (
        <div
            className={cx(`ProductBadge`, { [`me-${marginRight}`]: !!marginRight }, className)}
            style={style}
        >
            {badges.map((badge, index) => (
                <div
                    key={index}
                    className={'badge'}
                >
                    <p className='mb-0'>
                        {badge}
                    </p>
                </div>

            ))}
        </div>
    ) : null;
}

ProductBadge.propTypes = {
    style: px.objectOf(px.any),
    className: px.string,
    marginRight: px.string,
    badges: px.arrayOf(px.string),
    product: Product,
};
